/* eslint-disable no-console */
import axios from 'axios';
import { AUTH_TOKEN_KEY, cleanUpSessionData } from '@raisin/cp-utils';
const HTTP_RESPONSE = {
    FORBIDDEN: 403,
};
const createClient = (baseURL, useJwt) => {
    var _a;
    const headers = {
        'Content-Type': 'application/json',
    };
    if (useJwt) {
        const token = (_a = JSON.parse(localStorage.getItem(AUTH_TOKEN_KEY) || '{}')) === null || _a === void 0 ? void 0 : _a.access_token;
        if (token)
            headers['Authorization'] = `Bearer ${token}`;
    }
    const api = axios.create({
        withCredentials: true,
        baseURL,
        timeout: 3000,
        headers,
    });
    api.interceptors.response.use((res) => res.data, (error) => {
        if (error.response) {
            if (error.response.status === HTTP_RESPONSE.FORBIDDEN) {
                cleanUpSessionData();
            }
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx.
            // Before logging the error.response we have to remove the authorization header from
            // error.response.config.headers
            delete error.response.config.headers['Authorization'];
            console.error('An API endpoint responded with a non-2xx status code', {
                request: error.request,
                response: error.response,
            });
        }
        else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error("An API endpoint didn't respond to the request", { request: error.request });
        }
        else {
            // Something happened in setting up the request that triggered an Error
            console.error('An unexpected error happened during an API call', error);
        }
        return Promise.reject(error);
    });
    return api;
};
export default createClient;
//# sourceMappingURL=createClient.js.map